var _path, _path2, _path3;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgExclamationinline = function SvgExclamationinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 26 26"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#EF6922",
    fillRule: "evenodd",
    d: "M13 23a10 10 0 1 0 0-20 10 10 0 0 0 0 20Zm0 3a13 13 0 1 0 0-26 13 13 0 0 0 0 26Z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#EF6922",
    fillRule: "evenodd",
    d: "m13 5 2 2v8a2 2 0 1 1-4 0V7l2-2Z",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#EF6922",
    d: "M15 20a2 2 0 1 1-4 0 2 2 0 0 1 4 0Z"
  })));
};

export default SvgExclamationinline;